(() => {
  // Preview-only corrections verified against product descriptions on 2026-09-09.
  // Tarot packaging and mineral names do not make these incense products cards or stones.
  const incenseHandles = new Set([
    'sagrada-madre-strength-marseilio-taro-smilkalai',
    'sagrada-madre-the-empress-marseilio-taro-smilkalai',
    'sagrada-madre-temperance-marseilio-taro-smilkalai',
    'sagrada-madre-the-moon-marseilio-taro-smilkalai',
    'sagrada-madre-tarot-temperance-marseilio-taro',
    'sagrada-madre-tarot-the-star-marseilio-taro',
    'sagrada-madre-india-black-enigma-spiritual-guide',
    'sagrada-madre-copal-1-vnt',
    'noor-oud-topaz',
    'sagrada-madre-juodo-turmalino-rinkinys',
    'sagrada-madre-sacred-spiritual-guide',
    'tribal-soul-white-copal',
    'sagrada-madre-copal'
  ]);
  // Reviewed product-specific corrections: preserve genuine cards, stones and gift bags.
  const typeOverrides = new Map([
    ['auksinio-obsidiano-su-metatrono-kubu','Pakabukai'],
    ['kalnu-kristolo-mala-108','Karoliai'],
    ['ametisto-mala-108','Karoliai'],
    ['8-planetu-rinkinys','Mineralai'],
    ['aksominis-maiselis-su-7-cakromis','Taro maišeliai'],
    ['ritualine-taure-pentagrama','Ritualinės taurės'],
    ['triju-skyriu-taro-kortu-dezute','Taro dėžutės'],
    ['taro-kortu-dezute-trigubas-menulis','Taro dėžutės'],
    ['taro-kilimelis-gyvybes-medis-1','Kilimėliai'],
    ['taro-kilimelis-gyvybes-medis','Kilimėliai'],
    ['taro-kilimelis-zodiakas','Kilimėliai']
  ]);
  const productType = p => typeOverrides.get(p.handle) ?? (incenseHandles.has(p.handle) ? 'Smilkalai' : (p.product_type ?? p.type ?? ''));
  function order(products, mode='default') {
    const result=[...products];
    if(mode==='default')return [...result.filter(p=>p.available),...result.filter(p=>!p.available)];
    if(mode==='price-low')result.sort((a,b)=>a.cents-b.cents);
    if(mode==='price-high')result.sort((a,b)=>b.cents-a.cents);
    if(mode==='title')result.sort((a,b)=>a.title.localeCompare(b.title,'lt'));
    return result;
  }
  function groups(products) {
    if(products.length<48)return [];
    const counts=new Map();
    for(const p of products){const name=p.product_type;if(name?.trim())counts.set(name,(counts.get(name)||0)+1);}
    if(counts.size<2)return [];
    return [...counts].map(([name,count])=>({name,count})).sort((a,b)=>b.count-a.count||a.name.localeCompare(b.name,'lt'));
  }
  const longTitle=title=>title.length>45;
  const ringGuide=p=>/(?:^|\s)žied(?:as|ai)(?:\s|$)/iu.test(p.title||'')||/^žiedai$/iu.test(p.type||'');
  const api={order,groups,longTitle,ringGuide,productType};
  if(typeof module!=='undefined'&&module.exports)module.exports=api;
  else window.HDCatalogModel=api;
})();
